import { Component, Input } from '@angular/core';
import { Invite, InviteType } from '@ktypes/models';

@Component({
  selector: 'kui-invite',
  templateUrl: './invite.component.html',
  styleUrls: ['./invite.component.scss'],
})
export class InviteComponent {
  @Input() invite: Invite;
  modalOpened = false;
  inviteType = InviteType;
}
